import { AutoComplete, Col, PagedResponse } from '@elotech/components';
import { AxiosPromise } from 'axios';
import { Protocolo } from 'common/type';
import React, { FC, useEffect, useMemo, useState } from 'react';

export type ProtocoloSearchProps = {
  size?: number;
  name?: string;
  error?: string;
  value: Protocolo;
  showAutoComplete?: boolean;
  onSelect: (protocolo?: Protocolo) => void;
  onSearch: (search: string) => AxiosPromise<PagedResponse<Protocolo>>;
};

const initialValue: Protocolo = {
  anoProtocolo: '',
  numero: '',
  tipoProtocolo: ''
};

const ProtocoloSearch: FC<ProtocoloSearchProps> = ({
  value,
  error,
  size = 4,
  onSelect,
  name = 'protocolo',
  onSearch,
  showAutoComplete = true
}) => {
  const [protocolo, setProtocolo] = useState(initialValue);

  useEffect(() => {
    if (value) {
      const hasProtocolo = Object.values(value).every(item => !!item);
      if (hasProtocolo) {
        setProtocolo(value);
      }
    }
  }, [value]);

  const handleChange = ({ target }) => {
    const { name, value } = target;

    const protocolo: Protocolo = {
      ...value,
      [name]: value
    };

    setProtocolo(protocolo);
    onSelect(protocolo);
  };

  const sizeInputs = useMemo(() => {
    return Math.floor(size / 3);
  }, [size]);

  const sizeAutoComplete = useMemo(() => {
    return size - sizeInputs * 2;
  }, [size, sizeInputs]);

  return (
    <>
      <Col md={sizeAutoComplete}>
        <div className="form-group">
          <label htmlFor="protocolo" className="label">
            Protocolo
          </label>
          {showAutoComplete ? (
            <AutoComplete<Protocolo>
              autoFocus={false}
              name={name}
              value={protocolo}
              className={!!error ? 'error' : ''}
              getOptionValue={protocolo =>
                protocolo.numero ? `${protocolo.numero}` : undefined
              }
              getOptionLabel={protocolo =>
                protocolo.numero ? `${protocolo.numero}` : ''
              }
              onSearch={onSearch}
              onSelect={(_: string, value: Protocolo) => {
                const protocolo = value || initialValue;

                setProtocolo(protocolo);
                onSelect(protocolo);
              }}
            />
          ) : (
            <input
              id="protocolo"
              type="number"
              name="protocolo"
              value={protocolo.numero}
              className={!!error ? 'error' : ''}
              onChange={handleChange}
            />
          )}
          {!!error && <span className="help-message">{error}</span>}
        </div>
      </Col>
      <Col md={sizeInputs}>
        <div className="form-group">
          <label htmlFor="anoProtocolo" className="label">
            Ano
          </label>
          <input
            id="anoProtocolo"
            type="number"
            name="anoProtocolo"
            disabled={showAutoComplete}
            value={protocolo.anoProtocolo}
            onChange={handleChange}
          />
        </div>
      </Col>
      <Col md={sizeInputs}>
        <div className="form-group">
          <label htmlFor="tipoProtocolo" className="label">
            Tipo
          </label>
          <input
            id="tipoProtocolo"
            type="number"
            name="tipoProtocolo"
            disabled={showAutoComplete}
            value={protocolo.tipoProtocolo}
            onChange={handleChange}
          />
        </div>
      </Col>
    </>
  );
};

export { ProtocoloSearch };
